<template>
	<div>
		<modal
			:exibir="exibir"
			titulo="Adicionar Documento"
			:max-width="450"
			:is-confirmar-visivel="true"
			:custom-actions="false"
			:acao-confirmar="confirmar"
			nome-botao-confirmar="Salvar"
			:acao-cancelar="fecharModal"
			:is-confirmar-desabilitado="!formIsValid"
			@close="fecharModal"
		>
			<template #body>
				<v-form class="modal-novo-documento__form" ref="form" v-model="formIsValid" lazy-validation>
					<div>
						<label-personalizado nome-campo="Criar de um modelo?" class="mb-2"></label-personalizado>
						<v-radio-group v-model="isModeloDocumento" row class="ma-0 py-0">
							<v-radio label="Sim" :value="true"></v-radio>
							<v-radio label="Não" :value="false"></v-radio>
						</v-radio-group>
					</div>
					<v-row class="mb-1">
						<v-col cols="12">
							<label-personalizado
								nome-campo="Tipo Documento"
								:obrigatorio-por-padrao="true"
							></label-personalizado>
							<v-autocomplete
								id="modal-adicionar-documento-tipos-documentos"
								v-model="tipoDocumentoModelo"
								:items="tiposDocumentoModeloDataSource"
								placeholder="Selecione"
								class="ma-0 py-0"
								item-value="id"
								item-text="nome"
								dense
								clearable
								@change="buscarModelosDocumentos"
								:rules="regrasTipoDocumentoModelo"
							>
							</v-autocomplete>
						</v-col>
						<v-col cols="12" v-if="isModeloDocumento">
							<label-personalizado
								nome-campo="Selecione o Modelo"
								:obrigatorio-por-padrao="true"
							></label-personalizado>
							<v-autocomplete
								id="modal-adicionar-documento-selecionar-modelo"
								v-model="documentoModeloSelecionado"
								:items="documentoModeloDatasource"
								placeholder="Busque e selecione"
								class="ma-0 py-0"
								item-text="nome"
								append-icon="search"
								dense
								clearable
								:disabled="podePreencherDocumentoModelo"
								@change="preencherTituloDocumento"
								:rules="regrasDocumentoModelo"
								return-object
							>
							</v-autocomplete>
						</v-col>
						<v-col cols="12">
							<label-personalizado
								nome-campo="Título Documento"
								:obrigatorio-por-padrao="true"
							></label-personalizado>
							<v-text-field
								id="modal-adicionar-documento-titulo-documento"
								v-model="tituloDocumento"
								:rules="regrasTitulo"
								dense
								clearable
								type="string"
								counter="100"
								class="ma-0 py-0"
								placeholder="Informe o título aqui"
							></v-text-field>
						</v-col>
					</v-row>
				</v-form>
			</template>
		</modal>
	</div>
</template>
<script>
import Modal from '@/views/components/Modal.vue'
import LabelPersonalizado from '@/views/components/LabelPersonalizado.vue'
import validacaoFormulario from '@/views/mixins/validacaoFormulario'
import { actionTypes, mutationTypes } from '@/core/constants'
import documentoMixin from '@/views/mixins/documento'

export default {
	name: 'modal-adicionar-documentos-generico',
	components: { LabelPersonalizado, Modal },
	mixins: [validacaoFormulario, documentoMixin],
	props: {
		idEntidade: {
			type: Number,
			required: true,
		},
		exibir: {
			type: Boolean,
		},
		tipoDocumento: {
			type: Object,
			required: true,
		},
		buscarTodos: {
			type: Boolean,
			default: false,
		},
	},
	emits: ['fechar-modal'],
	data() {
		return {
			formIsValid: false,
			isModeloDocumento: true,
			tituloDocumento: '',
			tipoDocumentoModelo: null,
			tiposDocumentoModeloDataSource: [],
			documentoModeloSelecionado: null,
			documentoModeloDatasource: [],
			regrasTitulo: [(value) => this.regraObrigatoriedade(value, 'O campo é obrigatório.')],
			regrasTipoDocumentoModelo: [(value) => this.regraObrigatoriedade(value, 'O campo é obrigatório.')],
			regrasDocumentoModelo: [(value) => this.regraObrigatoriedade(value, 'O campo é obrigatório.')],
		}
	},
	computed: {
		podePreencherDocumentoModelo() {
			return (
				!this.tipoDocumentoModelo &&
				this.documentoModeloDatasource &&
				this.documentoModeloDatasource.length === 0
			)
		},
	},
	async mounted() {
		await this.carregarTiposModeloDocumento()
	},
	beforeDestroy() {
		this.$store.commit(mutationTypes.CONFIGURACAO.TIPO_MODELO_DOCUMENTO.RESET_FILTRO)
	},
	methods: {
		async carregarTiposModeloDocumento() {
			const { itens } = await this.$store.dispatch(
				actionTypes.CONFIGURACAO.TIPO_MODELO_DOCUMENTO.BUSCAR_TIPOS_MODELO_DOCUMENTOS_ATIVOS,
				{
					buscarTodosTipos: this.buscarTodos,
				},
			)

			this.tiposDocumentoModeloDataSource = itens
		},
		async buscarModelosDocumentos() {
			this.documentoModeloSelecionado = null
			this.setFiltroBuscaNaoPaginada()

			if (this.tipoDocumentoModelo) {
				const { itens } = await this.$store.dispatch(
					actionTypes.CONFIGURACAO.MODELO_DOCUMENTO.BUSCAR_MODELOS_DOCUMENTOS_ATIVOS,
				)

				this.documentoModeloDatasource = itens
			} else {
				this.documentoModeloDatasource = []
			}
		},
		async confirmar() {
			if (this.$refs.form.validate()) {
				await this.adicionarDocumento()
				this.fecharModal()
			}
		},
		async adicionarDocumento() {
			if (!this.isModeloDocumento) {
				this.documentoModeloSelecionado = null
			}

			const { urlEdicao } = await this.$store.dispatch(actionTypes.DOCUMENTOS.EDITOR_TEXTO.INSERIR_GENERICO, {
				tipo: this.tipoDocumento,
				model: this.montarDocumento(
					this.tituloDocumento.trim(),
					this.tipoDocumentoModelo,
					this.documentoModeloSelecionado,
					this.idEntidade,
				),
			})

			this.mostrarNotificacaoSucessoDefault()

			this.redirecionarPara(urlEdicao)
		},
		selecionarIdTipoDocumento() {
			return this.tiposDocumentoModeloDataSource.filter((item) => {
				return item.tipo === this.tipoDocumento
			})
		},
		preencherTituloDocumento(documento) {
			if (documento) {
				this.tituloDocumento = documento.nome
			} else {
				this.tituloDocumento = ''
			}
		},
		setFiltroBuscaNaoPaginada() {
			this.$store.commit(mutationTypes.CONFIGURACAO.MODELO_DOCUMENTO.SET_FILTRO_BUSCA_NAO_PAGINADA, {
				idTipoDocumento: this.tipoDocumentoModelo,
			})
		},
		resetFiltroBuscaNaoPaginada() {
			this.$store.commit(mutationTypes.CONFIGURACAO.MODELO_DOCUMENTO.RESET_FILTRO_BUSCA_NAO_PAGINADA)
		},
		montarDocumento(nome, tipo, documentoModelo, id) {
			return {
				titulo: nome,
				idTipoDocumento: tipo,
				idModeloDocumento: documentoModelo ? documentoModelo.id : null,
				idEntidade: id,
			}
		},
		limparFormulario() {
			this.tituloDocumento = ''
			this.tipoDocumentoModelo = null
			this.documentoModeloSelecionado = null
			this.documentoModeloDatasource = []
			this.isModeloDocumento = true
			this.formIsValid = false
		},
		fecharModal() {
			this.resetFiltroBuscaNaoPaginada()
			this.limparFormulario()
			this.$emit('fechar-modal')
		},
		// fecharDocumento() {
		// 	this.urlDocumento = null
		// 	this.exibirModalDocumento = false
		// },
		// exibirDocumento() {
		// 	this.exibirModalDocumento = true
		// },
	},
}
</script>
<style lang="stylus" scoped>
.modal-novo-documento__form
	margin-top: 0.9375rem
</style>
